// $(function () {
//     $(".VyberRegion").on("change", function () {
//         var url = $(this).val();
//         console.log('vybran region'+url);
//         //location.href='//<?=$_SERVER['HTTP_HOST']?>'+url;
//     });
//
// });
// $(function () {
//     $(".VyberOkres").on("change", function () {
//         var url = $(this).val();
//         console.log('vybran okres'+url);
//         //location.href='//<?=$_SERVER['HTTP_HOST']?>'+url;
//     });
//
// });
//
// $(function () {
//     $(".VyberObec").on("change", function () {
//         var url = $(this).val();
//         console.log('vybrana obec'+url);
//         //location.href='//<?=$_SERVER['HTTP_HOST']?>'+url;
//     });
//
// });

$('#search-firm').typeahead({
        hint: true,
        highlight: true,
        minLength: 2,
        autoselect: false,
        classNames: {
            wrapper: 'twitter-typeahead-firm',
        }
    },
    {
        displayKey: 'token',
        name: 'states',
        source: function (query, syncResults, asyncResults) {
            var results = [];
            $.get({url: "/firmy/ajax_firm/", dataType: "json", data: {maxRows: 12, name_startsWith: $("#search-firm").val(),url_kategorie: $("#url_kategorie").val(),paramname: $("#paramname").val(),paramvalue: $("#paramvalue").val()}}, function (json) {
                //console.log("ajax success");
                for (i in json.results) {
                    results.push(json.results[i]);
                    //console.log(json.results[i]);
                }
                console.log(results);
                asyncResults(results);
            });
        },
        templates: {
            //empty: ['Žádný výsledek'].join('\n'),
            suggestion: function (e) {
                return '<div>' + e.label + '</div>';
            }
        },
        limit: 10
    }

)

$('#search-firm').bind('typeahead:select', function (ev, suggestion) {
    if (suggestion.url!='') {
        console.log(suggestion.url);
        location.href = suggestion.url;
    }else{
        console.log('chybí url');
    }
});

$('#search-firm').bind('typeahead:asyncrequest', function (ev, suggestion) {
    console.log('spinner show');
    $('#search-firm').css('background-image', 'url("/images/ajax-loader.gif")');
    $('#search-firm').css('background-repeat', 'no-repeat');
    $('#search-firm').css('background-position', '95% center');

});
$('#search-firm').bind('typeahead:asyncreceive', function (ev, suggestion) {
    console.log('spinner hide');
    $('#search-firm').css('background-image', '');
});

